module.exports = __webpack_public_path__ + "assets/projects/robots-and-ai/transition.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/robots-and-ai/transition.mp4
// module id = 56
// module chunks = 0